<!-- eslint-disable max-len -->
<template>
  <div
    id="container-external-api"
    class="container-app-search">
    <h3 class="modal-title"> {{ fieldDetail ? 'EDIT FIELD': 'ADD FIELD' }} </h3>
    <b-row>
      <b-col
        :md="isHaveConfig ? '6' : '12'">
        <h4>Properties</h4>
        <b-form :class="{'error-input' : $v.dataSetup.type.$error}">
          <label> Type </label>
          <j-single-select
            v-model="dataSetup.type"
            :options="type === 'table_group' ? listTypeTable : listType"
            :placeholder="'Select Type'"
            value-format="object"
            label="text"/>
        </b-form>
        <b-row>
          <b-col md="6">
            <b-form :class="{'error-input' : $v.dataSetup.key.$error}">
              <label> Key </label>
              <j-input
                v-model="dataSetup.key"
                placeholder="Enter key"/>
            </b-form>
          </b-col>
          <b-col md="3">
            <b-form :class="{'error-input' : $v.dataSetup.isDisable.$error}">
              <label> Disable </label>
              <j-toggle
                v-model="dataSetup.isDisable"
                :disabled="isDisabledField" />
            </b-form>
          </b-col>
          <b-col md="3">
            <b-form :class="{'error-input' : $v.dataSetup.isMandatory.$error}">
              <label> Mandatory </label>
              <j-toggle v-model="dataSetup.isMandatory" />
            </b-form>
          </b-col>
        </b-row>
        <b-form :class="{'error-input' : $v.dataSetup.name.$error}">
          <label> Name </label>
          <j-input
            v-model="dataSetup.name"
            placeholder="Enter field name"/>
        </b-form>
        <b-form :class="{'error-input' : $v.dataSetup.placeholder.$error}">
          <label> Placeholder </label>
          <j-input
            v-model="dataSetup.placeholder"
            placeholder="Enter field placeholder"/>
        </b-form>
        <b-form :class="{'error-input' : $v.dataSetup.grid.$error}">
          <label> Grid </label>
          <j-single-select
            v-model="dataSetup.grid"
            :options="listGrid"
            :placeholder="'Select Grid'"
            :disabled="isNoGrid"
            label="text"/>
        </b-form>
        <div v-show="dataSetup.type && (dataSetup.type.id !== 'separator' && dataSetup.type.id !== 'custom_html')">
          <h4>Parse Value To</h4>
          <b-form :class="{'error-input' : $v.dataSetup.variable.$error}">
            <label> Variable </label>
            <j-input
              v-if="isExternal"
              v-model="dataSetup.variable"
              placeholder="Enter source"/>
            <j-single-select
              v-else
              v-model="dataSetup.variable"
              :options="variableOptions"
              :placeholder="'Select Variable'"
              value-format="object"
              label="label"/>
          </b-form>
        </div>
      </b-col>
      <b-col
        v-if="isHaveConfig"
        md="6">
        <div v-if="dataSetup.type.id === 'location'">
          <h4>Config</h4>
          <b-form :class="{'error-input' : $v.dataSetup.locationType.$error}">
            <label> Location Type </label>
            <j-single-select
              v-model="dataSetup.locationType"
              :options="listLocationType"
              :placeholder="'Select Location Type'"
              label="text"/>
          </b-form>
        </div>
        <div
          v-if="dataSetup.type.id === 'single_selection'||
            dataSetup.type.id === 'multiple_selection'||
            dataSetup.type.id === 'photo' ||
            dataSetup.type.id === 'attachment' ||
            dataSetup.type.id === 'radio' ||
            dataSetup.type.id === 'checkbox'
          ">
          <h4>Options</h4>
          <div
            v-for="(itemOptions, index) in dataSetup.options"
            :key="index">
            <b-row>
              <b-col md="10">
                <b-form :class="{'error-input' : $v.dataSetup.options.$each[index].$error}">
                  <j-input
                    v-model="dataSetup.options[index]"
                    placeholder="Enter options"/>
                </b-form>
              </b-col>
              <b-col
                md="2"
                class="p__l--1 m__t--5">
                <i
                  class="fa fa-trash cursor-pointer"
                  @click="deleteOptions(index)"/>
              </b-col>
            </b-row>
          </div>
          <b-row>
            <b-col cols="12">
              <button
                class="btn btn-add-column m__b--15"
                @click="addoptions">
                + Add options
              </button>
            </b-col>
          </b-row>
        </div>
        <div v-if="dataSetup.type.id === 'attachment' || dataSetup.type.id === 'multiple_attachment_dynamic' || dataSetup.type.id === 'single_attachment'">
          <b-form :class="{'error-input' : $v.dataSetup.acceptedFileType.$error}">
            <label> Accepted File Type </label>
            <j-multi-select
              v-model="$v.dataSetup.acceptedFileType.$model"
              :options="list_accepted_file_type"
              placeholder="Select Accepted File Type"/>
          </b-form>
          <b-form :class="{'error-input' : $v.dataSetup.isUseCamera.$error}">
            <label> Use Camera </label>
            <j-toggle v-model="dataSetup.isUseCamera" />
          </b-form>
          <div v-if="dataSetup.isUseCamera">
            <b-form :class="{'error-input' : $v.dataSetup.sourceCamera.$error}">
              <label> Source </label>
              <b-form-radio-group
                v-model="$v.dataSetup.sourceCamera.$model"
                :options="list_source_camera"
                :stacked="true"
                class="jFormGroup"/>
            </b-form>
            <b-form :class="{'error-input' : $v.dataSetup.chooseCamera.$error}">
              <label> Choose Camera </label>
              <j-single-select
                v-model="$v.dataSetup.chooseCamera.$model"
                :options="list_choose_camera"
                placeholder="Choose Camera"/>
            </b-form>
          </div>
        </div>
        <div
          v-if="dataSetup.type.id === 'relation_record' ||
          dataSetup.type.id === 'multiple_relation_record'">
          <h4>Source Data</h4>
          <b-form :class="{'error-input' : $v.dataSetup.sourceData.tableGroup.$error}">
            <label> Table Group </label>
            <j-single-select
              v-model="$v.dataSetup.sourceData.tableGroup.$model"
              :options="tableGroupOptions"
              :placeholder="'Select Table Group'"
              value-format="object"
              label="name"/>
          </b-form>
          <b-form :class="{'error-input' : $v.dataSetup.sourceData.form.$error}">
            <label> Table </label>
            <j-single-select
              v-model="$v.dataSetup.sourceData.form.$model"
              :disabled="!dataSetup.sourceData.tableGroup"
              :options="tableOptions"
              :placeholder="'Select Table'"
              value-format="object"
              label="name"/>
          </b-form>
          <b-form :class="{'error-input' : $v.dataSetup.sourceData.showData.$error}">
            <label> Show Data Option </label>
            <j-single-select
              v-model="$v.dataSetup.sourceData.showData.$model"
              :options="list_field"
              label="name"
              placeholder="Select Variable"/>
          </b-form>
          <b-form :class="{'error-input' : $v.dataSetup.sourceData.searchData.$error}">
            <label> Search Data Option </label>
            <j-single-select
              v-model="$v.dataSetup.sourceData.searchData.$model"
              :options="list_field"
              label="name"
              placeholder="Select Variable"/>
          </b-form>
          <b-form :class="{'error-input' : $v.dataSetup.sourceData.setValue.$error}">
            <label> Set Value Selected </label>
            <j-single-select
              v-model="$v.dataSetup.sourceData.setValue.$model"
              :options="list_field"
              label="name"
              placeholder="Select Variable"/>
          </b-form>
        </div>
        <div
          v-if="dataSetup.type.id === 'relation_record_external_api' ||
          dataSetup.type.id === 'multiple_relation_record_external_api'">
          <h4>Source Data</h4>
          <div class="external-ui">
            External API <br>
            <span
              id="externalApiAdd"
              class="font-blue cursor-pointer">
              Config
            </span>
          </div>
          <b-form :class="{'error-input' : $v.dataSetup.sourceExternalVariable.$error}">
            <label> Show Data Option </label>
            <j-input
              v-model="dataSetup.sourceExternalVariable"
              placeholder="Enter variable"/>
          </b-form>
          <b-form :class="{'error-input' : $v.dataSetup.sourceExternalSetValue.$error}">
            <label> Set Value Selected </label>
            <j-single-select
              v-model="$v.dataSetup.sourceExternalSetValue.$model"
              :options="list_field_external"
              placeholder="Select Variable"/>
          </b-form>

          <b-popover
            ref="popoverExternalApi"
            :show.sync="popoverExternalApiShow"
            target="externalApiAdd"
            container="container-external-api"
            triggers="click"
            placement="left">
            <j-external-api-field
              :data-edit="dataSetup.sourceExternal"
              @submit-data="submitExternalUrl"
              @close-modal="closeModalExternalUrl"
            />
          </b-popover>
        </div>
        <div v-if="dataSetup.type.id === 'single_tags_selection' || dataSetup.type.id === 'multiple_tags_selection'">
          <h4 class="p__b--10">Options</h4>
          <div
            v-for="(item, index) in dataSetup.tags"
            :key="index"
            class="container-group__item">
            <span class="item__counter-group">
              {{ index + 1 }}
            </span>
            <span
              class="item__remove cursor-pointer"
              @click="deleteTags(index)">
              <i class="fa fa-trash fa-2x"/>
            </span>

            <b-form>
              <label> Name </label>
              <j-input
                v-model="item.name"
                placeholder="Enter tags name"/>
            </b-form>

            <b-row>
              <b-col md="6">
                <j-color-picker
                  v-model="item.background"
                  :color="item.background"
                  label="Background"
                  picker="chrome" />
              </b-col>
              <b-col md="6">
                <j-color-picker
                  v-model="item.font_color"
                  :color="item.font_color"
                  label="Font Color"
                  picker="chrome" />
              </b-col>
            </b-row>
          </div>

          <b-row>
            <b-col cols="12">
              <button
                class="btn btn-add-column m__b--15"
                @click="addTags">
                + Add options
              </button>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>

    <div class="float-right">
      <b-button
        class="btn m__r--5"
        @click="closeModal">
        Close
      </b-button>
      <b-button
        class="btn blue"
        @click="submitForm">
        {{ fieldDetail ? 'Update' : 'Add' }}
      </b-button>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-nested-ternary, max-len */
import { required, requiredIf } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import jwtDecode from 'jwt-decode';
import jExternalApiField from '@/views/experience-manager/external-api/jExternalApiField';
import jColorPicker from '@/components/color-picker/jColorPicker';

export default {
  components: {
    jExternalApiField,
    jColorPicker,
  },
  props: {
    fieldDetail: {
      type: Object,
      default: () => {},
    },
    variableOptions: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: '',
    },
    isExternal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataSetup: {
        name: null,
        placeholder: null,
        type: { id: 'text' },
        variable: null,
        isMandatory: false,
        isDisable: false,
        key: null,
        locationType: 1,
        options: [''],
        acceptedFileType: [],
        isUseCamera: false,
        sourceData: {
          tableGroup: null,
          form: null,
          showData: null,
          searchData: null,
          setValue: null,
        },
        sourceExternal: null,
        sourceExternalVariable: '',
        sourceExternalSetValue: '',
        tags: [],
        sourceCamera: null,
        chooseCamera: null,
        grid: null,
      },
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
      listType: [
        { id: 'text', text: 'Text' },
        { id: 'descriptive', text: 'Long Text' },
        { id: 'number', text: 'Number' },
        { id: 'number_decimal', text: 'Number (Decimal)' },
        { id: 'date', text: 'Date' },
        { id: 'time', text: 'Time' },
        { id: 'location', text: 'Maps' },
        { id: 'single_selection', text: 'Single Selection' },
        { id: 'multiple_selection', text: 'Multiple Selection' },
        { id: 'user_single_selection', text: 'User Single Selection' },
        { id: 'relation_record', text: 'Relation Record' },
        { id: 'multiple_relation_record', text: 'Multiple Relation Record' },
        { id: 'relation_record_external_api', text: 'Relation Record External API' },
        { id: 'multiple_relation_record_external_api', text: 'Multiple Relation Record External API' },
        { id: 'currency', text: 'Currency' },
        { id: 'attachment', text: 'Multiple Attachment' },
        { id: 'multiple_attachment_dynamic', text: 'Multiple Attachment Dynamic' },
        { id: 'single_attachment', text: 'Single Attachment' },
        { id: 'separator', text: 'Separator' },
        { id: 'radio', text: 'Radio' },
        { id: 'checkbox', text: 'Checkbox' },
        { id: 'single_tags_selection', text: 'Single Tags Selection' },
        { id: 'multiple_tags_selection', text: 'Multiple Tags Selection' },
      ],
      listTypeTable: [
        { id: 'text', text: 'Text' },
        { id: 'number', text: 'Number' },
        { id: 'number_decimal', text: 'Number (Decimal)' },
        { id: 'date', text: 'Date' },
        { id: 'time', text: 'Time' },
        { id: 'single_selection', text: 'Single Selection' },
        { id: 'multiple_selection', text: 'Multiple Selection' },
        { id: 'relation_record', text: 'Relation Record' },
        { id: 'multiple_relation_record', text: 'Multiple Relation Record' },
        { id: 'relation_record_external_api', text: 'Relation Record External API' },
        { id: 'multiple_relation_record_external_api', text: 'Multiple Relation Record External API' },
        { id: 'currency', text: 'Currency' },
        { id: 'radio', text: 'Radio' },
        { id: 'checkbox', text: 'Checkbox' },
      ],
      listLocationType: [
        { id: 1, text: 'Current Location' },
        { id: 2, text: 'Manual Location' },
        { id: 3, text: 'All Type' },
      ],
      list_field_external: [
        { id: 'all', text: 'All' },
        { id: 'id', text: 'ID' },
      ],
      list_accepted_file_type: [
        { id: 'png', text: 'PNG' },
        { id: 'jpg', text: 'JPG' },
        { id: 'jpeg', text: 'JPEG' },
        { id: 'csv', text: 'CSV' },
        { id: 'txt', text: 'TXT' },
        { id: 'xls', text: 'XLS' },
        { id: 'xlsx', text: 'XLSX' },
        { id: 'docx', text: 'DOCX' },
        { id: 'doc', text: 'DOC' },
        { id: 'pdf', text: 'PDF' },
        { id: 'ppt', text: 'PPT' },
        { id: 'pptx', text: 'PPTX' },
        { id: 'mp4', text: 'MP4' },
      ],
      list_choose_camera: [
        { id: 1, text: 'Main & Selfie Camera' },
        { id: 2, text: 'Selfie Camera' },
        { id: 3, text: 'Main Camera' },
      ],
      list_source_camera: [
        { value: true, text: 'Camera & Gallery' },
        { value: false, text: 'Camera Only' },
      ],
      listGrid: [
        { id: 12, text: 12 },
        { id: 11, text: 11 },
        { id: 10, text: 10 },
        { id: 9, text: 9 },
        { id: 8, text: 8 },
        { id: 7, text: 7 },
        { id: 6, text: 6 },
        { id: 5, text: 5 },
        { id: 4, text: 4 },
        { id: 3, text: 3 },
        { id: 2, text: 2 },
        { id: 1, text: 1 },
      ],
      list_field: [],
      tableGroupOptions: [],
      tableOptions: [],
      popoverExternalApiShow: false,
      finishSetDataTableGroup: false,
    };
  },
  computed: {
    isHaveConfig() {
      if (this.dataSetup.type) {
        const typeNotConfig = ['text', 'descriptive', 'number', 'number_decimal', 'date', 'time', 'user_single_selection', 'currency', 'group',
          'formula', 'custom_formula', 'separator', 'multiplier', 'multiplier_percentage', 'countdown', 'attendance', 'relation_record_with_child',
          'sum_value_group', 'table_group', 'group_selected'];
        return !typeNotConfig.includes(this.dataSetup.type.id);
      }
      return false;
    },

    isDisabledField() {
      return this.type === 'relation_record' || this.type === 'relation_record_external_api';
    },

    isNoGrid() {
      if (this.dataSetup.type) {
        const typeNotGrid = ['location', 'attachment', 'multiple_attachment_dynamic', 'single_attachment', 'separator', 'custom_html', 'group', 'table_group'];
        return typeNotGrid.includes(this.dataSetup.type.id) || ((this.dataSetup.type.id === 'radio' || this.dataSetup.type.id === 'checkbox') && this.dataSetup.optionsObject.length > 2) || this.isBulk;
      }
      return false;
    },
  },
  watch: {
    // eslint-disable-next-line
    'dataSetup.sourceData.tableGroup': function (val) {
      if (this.finishSetDataTableGroup) this.dataSetup.sourceData.form = null;
      setTimeout(() => { this.$v.dataSetup.$reset(); }, 10);

      if (val) {
        const reqTable = {
          tablegroup_id: val.id,
          search: '',
        };
        this.getListTableByGroupV2(reqTable).then((res) => {
          if (!res.error) {
            this.tableOptions = res.data || [];
          }
        });
      }
    },

    // eslint-disable-next-line
    'dataSetup.sourceData.form': function(data) {
      const dataColumns = Object.values(data.columns);
      this.list_field = dataColumns.map((e) => {
        e.id = e.name;
        e.text = e.name;
        e.label = e.name;
        return e;
      });
    },

    // eslint-disable-next-line
    'dataSetup.key': function (val){
      const regexSymbol = /[^\w\s]/g;
      setTimeout(() => {
        this.dataSetup.key =
          val.toLowerCase()
            .replace(regexSymbol, '')
            .replace(' ', '_');
      }, 1);
    },

    // eslint-disable-next-line
    'dataSetup.isUseCamera': function (val){
      this.dataSetup.sourceCamera = null;
      this.dataSetup.chooseCamera = null;
    },

    // eslint-disable-next-line
    'dataSetup.type': function (val){
      if (val) {
        const typeNotGrid = ['location', 'attachment', 'separator', 'custom_html', 'group', 'table_group'];
        if (typeNotGrid.includes(val.id)) {
          this.dataSetup.grid = 12;
        } else {
          this.dataSetup.grid = null;
        }
      }
    },

    // eslint-disable-next-line
    'dataSetup.optionsObject': function (val){
      if (this.dataSetup.type && (this.dataSetup.type.id === 'radio' || this.dataSetup.type.id === 'checkbox') && val.length > 2) {
        this.dataSetup.grid = 12;
      } else {
        this.dataSetup.grid = null;
      }
    },
  },
  created() {
    this.getListGroupTable();
    if (this.fieldDetail) {
      this.dataSetup = {
        name: this.fieldDetail.name,
        placeholder: this.fieldDetail.placeholder,
        type: { id: this.fieldDetail.type },
        variable: this.isExternal ? this.fieldDetail.field_data_key : { id: this.fieldDetail.field_data_key },
        isMandatory: this.fieldDetail.is_mandatory,
        isDisable: this.fieldDetail.is_disable,
        key: this.fieldDetail.field_ui_key,
        locationType: this.fieldDetail.type === 'location' ? this.fieldDetail.config.map_type : 1,
        options: this.fieldDetail.type === 'single_selection' ||
            this.fieldDetail.type === 'multiple_selection' ||
            this.fieldDetail.type === 'photo' ||
            this.fieldDetail.type === 'attachment' ||
            this.fieldDetail.type === 'radio' ||
            this.fieldDetail.type === 'checkbox' ? this.fieldDetail.config.list_options : [''],
        acceptedFileType: this.fieldDetail.type === 'attachment' ||
            this.fieldDetail.type === 'single_attachment' ||
            this.fieldDetail.type === 'multiple_attachment_dynamic' ? this.fieldDetail.config.accepted_file_type : [],
        isUseCamera: this.fieldDetail.type === 'attachment' ||
            this.fieldDetail.type === 'single_attachment' ||
            this.fieldDetail.type === 'multiple_attachment_dynamic' ? this.fieldDetail.config.is_use_camera : false,
        sourceData: {
          tableGroup: this.fieldDetail.type === 'relation_record' ||
            this.fieldDetail.type === 'multiple_relation_record' ? this.fieldDetail.config.data_source.table_group : null,
          form: this.fieldDetail.type === 'relation_record' ||
            this.fieldDetail.type === 'multiple_relation_record' ? this.fieldDetail.config.data_source.form : null,
          showData: this.fieldDetail.type === 'relation_record' ||
            this.fieldDetail.type === 'multiple_relation_record' ? this.fieldDetail.config.data_source.show_data_option : null,
          searchData: this.fieldDetail.type === 'relation_record' ||
            this.fieldDetail.type === 'multiple_relation_record' ? this.fieldDetail.config.data_source.search_data_option : null,
          setValue: this.fieldDetail.type === 'relation_record' ||
            this.fieldDetail.type === 'multiple_relation_record' ? this.fieldDetail.config.data_source.set_value_selected : null,
        },
        sourceExternal: this.fieldDetail.type === 'relation_record_external_api' ||
            this.fieldDetail.type === 'multiple_relation_record_external_api' ? this.fieldDetail.config.data_source_external : null,
        sourceExternalVariable: this.fieldDetail.type === 'relation_record_external_api' ||
            this.fieldDetail.type === 'multiple_relation_record_external_api' ? this.fieldDetail.config.data_source_external_variable : '',
        sourceExternalSetValue: this.fieldDetail.type === 'relation_record_external_api' ||
            this.fieldDetail.type === 'multiple_relation_record_external_api' ? this.fieldDetail.config.data_source_external_set_value : '',
        tags: this.fieldDetail.type === 'single_tags_selection' || this.fieldDetail.type === 'multiple_tags_selection' ? this.fieldDetail.config.list_tags : [],
        sourceCamera: this.fieldDetail.type === 'attachment' ||
            this.fieldDetail.type === 'single_attachment' ||
            this.fieldDetail.type === 'multiple_attachment_dynamic' ? this.fieldDetail.config.is_can_access_gallery : null,
        chooseCamera: this.fieldDetail.type === 'attachment' ||
            this.fieldDetail.type === 'single_attachment' ||
            this.fieldDetail.type === 'multiple_attachment_dynamic' ? this.fieldDetail.config.camera_type : null,
        grid: this.fieldDetail.grid_size ? this.fieldDetail.grid_size : null,
      };
      setTimeout(() => {
        this.dataSetup.sourceCamera = this.fieldDetail.type === 'attachment' ||
            this.fieldDetail.type === 'single_attachment' ||
            this.fieldDetail.type === 'multiple_attachment_dynamic' ? this.fieldDetail.config.is_can_access_gallery : null;
        this.dataSetup.chooseCamera = this.fieldDetail.type === 'attachment' ||
            this.fieldDetail.type === 'single_attachment' ||
            this.fieldDetail.type === 'multiple_attachment_dynamic' ? this.fieldDetail.config.camera_type : null;
        this.dataSetup.grid = this.fieldDetail.grid_size ? this.fieldDetail.grid_size : null;
      }, 500);
    } else {
      this.dataSetup = {
        name: null,
        placeholder: null,
        type: { id: 'text' },
        variable: null,
        isMandatory: false,
        isDisable: this.isDisabledField,
        key: null,
        locationType: 1,
        options: [''],
        acceptedFileType: [],
        isUseCamera: false,
        sourceData: {
          tableGroup: null,
          form: null,
          showData: null,
          searchData: null,
          setValue: null,
        },
        sourceExternal: null,
        sourceExternalVariable: '',
        sourceExternalSetValue: '',
        tags: [
          {
            name: '',
            background: '#000000',
            font_color: '#000000',
          },
        ],
        sourceCamera: null,
        chooseCamera: null,
        grid: null,
      };

      this.$v.dataSetup.$reset();
    }
  },
  methods: {
    // ...mapActions('jStoreFormUi', ['actionSetForm']),
    ...mapActions('jStoreForm', ['getListDataGroupByCompanyId', 'getListTableByGroupV2']),

    submitForm() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        const { name, placeholder, type, variable, isMandatory, isDisable, key, grid } = this.dataSetup;
        let dataConfig = null;
        if (this.dataSetup.type.id === 'location') {
          dataConfig = { map_type: this.dataSetup.locationType };
        }
        if (this.dataSetup.type.id === 'single_selection' ||
            this.dataSetup.type.id === 'multiple_selection' ||
            this.dataSetup.type.id === 'photo' ||
            this.dataSetup.type.id === 'radio' ||
            this.dataSetup.type.id === 'checkbox') {
          dataConfig = { list_options: this.dataSetup.options };
        }
        if (this.dataSetup.type.id === 'attachment') {
          dataConfig = {
            list_options: this.dataSetup.options,
            accepted_file_type: this.dataSetup.acceptedFileType,
            is_use_camera: this.dataSetup.isUseCamera,
            is_can_access_gallery: this.dataSetup.sourceCamera,
            camera_type: this.dataSetup.chooseCamera,
          };
        }
        if (this.dataSetup.type.id === 'single_attachment' || this.dataSetup.type.id === 'multiple_attachment_dynamic') {
          dataConfig = {
            list_options: [],
            accepted_file_type: this.dataSetup.acceptedFileType,
            is_use_camera: this.dataSetup.isUseCamera,
            is_can_access_gallery: this.dataSetup.sourceCamera,
            camera_type: this.dataSetup.chooseCamera,
          };
        }
        if (this.dataSetup.type.id === 'relation_record' ||
            this.dataSetup.type.id === 'multiple_relation_record') {
          dataConfig = {
            data_source: {
              table_group: this.dataSetup.sourceData.tableGroup,
              form: this.dataSetup.sourceData.form,
              show_data_option: this.dataSetup.sourceData.showData,
              search_data_option: this.dataSetup.sourceData.searchData,
              set_value_selected: this.dataSetup.sourceData.setValue,
            },
          };
        }
        if (this.dataSetup.type.id === 'relation_record_external_api' ||
            this.dataSetup.type.id === 'multiple_relation_record_external_api') {
          dataConfig = {
            data_source_external: this.dataSetup.sourceExternal,
            data_source_external_variable: this.dataSetup.sourceExternalVariable,
            data_source_external_set_value: this.dataSetup.sourceExternalSetValue,
          };
        }
        if (this.dataSetup.type.id === 'single_tags_selection' || this.dataSetup.type.id === 'multiple_tags_selection') {
          dataConfig = { list_tags: this.dataSetup.tags };
        }
        const params = {
          name,
          placeholder,
          type: type.id,
          field_data_key: variable ? (this.isExternal ? variable : variable.id) : '',
          is_mandatory: isMandatory,
          is_disable: isDisable,
          field_ui_key: key,
          grid_size: grid,
          config: dataConfig,
        };

        if (this.fieldDetail) {
          this.$emit('submit-mode', 'edit', params);
        } else {
          this.$emit('submit-mode', 'add', params);
        }
        this.$emit('close-modal');
      }
    },
    closeModal() {
      this.dataSetup = {
        name: null,
        placeholder: null,
        type: { id: 'text' },
        variable: null,
        isMandatory: false,
        isDisable: false,
        key: null,
        locationType: 1,
        options: [''],
        acceptedFileType: [],
        isUseCamera: false,
        sourceData: {
          tableGroup: null,
          form: null,
          showData: null,
          searchData: null,
          setValue: null,
        },
        sourceExternal: null,
        sourceExternalVariable: '',
        sourceExternalSetValue: '',
        tags: [
          {
            name: '',
            background: '#000000',
            font_color: '#000000',
          },
        ],
        sourceCamera: null,
        chooseCamera: null,
        grid: null,
      };

      this.$v.dataSetup.$reset();
      this.$emit('close-modal');
    },
    addoptions() {
      this.dataSetup.options.push('');
    },
    deleteOptions(index) {
      this.dataSetup.options.splice(index, 1);
    },
    addTags() {
      this.dataSetup.tags.push({
        name: '',
        background: '#000000',
        font_color: '#000000',
      });
    },
    deleteTags(index) {
      this.dataSetup.tags.splice(index, 1);
    },
    loadOptionsForm({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const dataFilter = {
            name: searchQuery,
            company_id: this.session.user.company_id,
          };
          const reqData = {
            limit: 50,
            page: 1,
            filter: JSON.stringify(dataFilter),
          };
          this.$store.dispatch('jStoreAutomation/getListForm', { reqData, callback });
        } else {
          callback(null, false);
        }
      }
    },
    closeModalExternalUrl() {
      this.popoverExternalApiShow = false;
    },
    submitExternalUrl(data) {
      this.dataSetup.sourceExternal = data;
      this.popoverExternalApiShow = false;
    },
    getListGroupTable() {
      this.getListDataGroupByCompanyId().then((res) => {
        if (!res.error) {
          this.tableGroupOptions = res.data || [];

          if (this.fieldDetail.config && this.fieldDetail.config.data_source && !this.fieldDetail.config.data_source.table_group) {
            const formDataTableGroup = this.fieldDetail.config &&
            this.fieldDetail.config.data_source &&
            this.fieldDetail.config.data_source.form &&
            this.fieldDetail.config.data_source.form.tablegroup_id;
            const findTableGroup = res.data.find(f => f.id === formDataTableGroup);
            if (findTableGroup) {
              this.dataSetup.sourceData.tableGroup = findTableGroup;
            }
            const findTableGroupLegacy = res.data.find(f => f.id === 'legacy');
            if (findTableGroupLegacy && !formDataTableGroup) {
              this.dataSetup.sourceData.tableGroup = findTableGroupLegacy;
            }

            setTimeout(() => {
              this.dataSetup.sourceData.form = this.fieldDetail.type === 'relation_record' ||
                this.fieldDetail.type === 'multiple_relation_record' ? this.fieldDetail.config.data_source.form : null;
            }, 500);
          }

          setTimeout(() => { this.finishSetDataTableGroup = true; }, 1000);
        }
      });
    },
  },
  validations() {
    return {
      dataSetup: {
        name: {
          required,
        },
        placeholder: {
          // required,
        },
        type: {
          required,
        },
        variable: {
          // required,
          required: requiredIf(() => this.dataSetup.type && (this.dataSetup.type.id !== 'separator' && this.dataSetup.type.id !== 'custom_html')),
        },
        isMandatory: {
          // required,
        },
        isDisable: {
          // required,
        },
        key: {
          required,
        },
        locationType: {
          required: requiredIf(() => (this.dataSetup.type && this.dataSetup.type.id) === 'location'),
        },
        options: {
          $each: {
            // eslint-disable-next-line arrow-body-style
            required: requiredIf(() => {
              return (this.dataSetup.type && this.dataSetup.type.id) === 'single_selection' ||
                      (this.dataSetup.type && this.dataSetup.type.id) === 'multiple_selection' ||
                      (this.dataSetup.type && this.dataSetup.type.id) === 'attachment';
            }),
          },
        },
        acceptedFileType: {
          required: requiredIf(() => (this.dataSetup.type && this.dataSetup.type.id) === 'attachment'),
        },
        isUseCamera: {},
        sourceData: {
          tableGroup: {
            // eslint-disable-next-line arrow-body-style
            required: requiredIf(() => {
              return (this.dataSetup.type && this.dataSetup.type.id) === 'relation_record' ||
                      (this.dataSetup.type && this.dataSetup.type.id) === 'multiple_relation_record';
            }),
          },
          form: {
            // eslint-disable-next-line arrow-body-style
            required: requiredIf(() => {
              return (this.dataSetup.type && this.dataSetup.type.id) === 'relation_record' ||
                      (this.dataSetup.type && this.dataSetup.type.id) === 'multiple_relation_record';
            }),
          },
          showData: {
            // eslint-disable-next-line arrow-body-style
            required: requiredIf(() => {
              return (this.dataSetup.type && this.dataSetup.type.id) === 'relation_record' ||
                      (this.dataSetup.type && this.dataSetup.type.id) === 'multiple_relation_record';
            }),
          },
          searchData: {
            // eslint-disable-next-line arrow-body-style
            required: requiredIf(() => {
              return (this.dataSetup.type && this.dataSetup.type.id) === 'relation_record' ||
                      (this.dataSetup.type && this.dataSetup.type.id) === 'multiple_relation_record';
            }),
          },
          setValue: {
            // eslint-disable-next-line arrow-body-style
            required: requiredIf(() => {
              return (this.dataSetup.type && this.dataSetup.type.id) === 'relation_record' ||
                      (this.dataSetup.type && this.dataSetup.type.id) === 'multiple_relation_record';
            }),
          },
        },
        sourceExternalVariable: {},
        sourceExternalSetValue: {},
        sourceCamera: {},
        chooseCamera: {},
        grid: {},
      },
    };
  },
};
</script>

<style lang="scss" scoped>
  .btn-add-column {
    color: #808285;
    padding: 0;
    margin-bottom: 16px;
  }

  .external-ui {
    height: 50px;
    margin: 7px 0 22px;
    padding: 12px 138px 11px 14px;
    border-radius: 8px;
    background-color: #f3f3f3;
    font-family: Poppins-Medium;
    font-size: 12px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #626262;
  }

  .font-blue {
    color: #1a85e4 !important;
  }

  .container-group__item {
    border-top: 1px solid #ccc;
    padding: 10px 30px;
    position: relative;
  }

  .item__counter-group {
    position: absolute;
    top: -14px;
    left: 0;
    border: 1px solid #ccc;
    background-color: #fff;
    border-radius: 13px;
    width: 26px;
    height: 26px;
    padding-top: 3px;
    font-size: 12px;
    text-align: center;
  }

  .item__remove {
    position: absolute;
    top: -14px;
    right: 0;
    background-color: #fff;
  }

</style>



// WEBPACK FOOTER //
// src/views/experience-manager/menu/jColumnEditFill.vue